module.exports = __webpack_public_path__ + "img/octagon-minus.cef4ac57.svg";